export default __webpack_public_path__ + "static/media/BANNER_tablet_ConT.1de5be47.svg";